var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"program",attrs:{"id":`program-${_vm.program.id}`}},[_c('v-radio',{class:{ active: _vm.isSelected },attrs:{"id":`program-${_vm.program.id}`,"label":`${_vm.program.name} - ${_vm.program.description} - sessions: ${_vm.program.no_of_sessions}`,"value":_vm.program,"color":"#5FD068","active-class":"active"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }